import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { permanentRedirect } from '../helpers';

export default function TemplateRedirect() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const id = params.get('id');
  const redirect = permanentRedirect(navigate);

  useEffect(() => {
    if (pathname === '/template') {
      redirect('/templates');
      return;
    }

    // NOTE: the old router assummed that if you hit these paths that an `id` query would be
    // present. maintain this assumption for now. consider redirecting to 404 route
    // if id is falsy

    if (pathname.endsWith('/edit')) {
      redirect(`/templates/${id}`);
      return;
    }

    if (pathname.endsWith('/events')) {
      redirect(`/templates/${id}/events`);
      return;
    }

    // all other /template routes are not supported
    redirect('/error/404');
  }, [id, pathname]);

  return null;
}
